import { combineReducers } from '@reduxjs/toolkit';
import orderReducer from './reducers/orderReducer';
import postReducer from './reducers/postReducer';
import usersReducer from './reducers/businessReducer';

const reducers = combineReducers({
  order: orderReducer,
  users: usersReducer,
  post: postReducer,
});

export default reducers;
